import { render } from "./kalio-user-card.vue?vue&type=template&id=eab78554"
import script from "./kalio-user-card.vue?vue&type=script&lang=js"
export * from "./kalio-user-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__